import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slice/userSlice";
import offlineSlice from "./slice/offlineSlice";

const store = configureStore({
  reducer: {
    userReducer: userSlice,
    offlineReducer: offlineSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
